import { render, staticRenderFns } from "./VButtonGroup.vue?vue&type=template&id=06d3be78&"
import script from "./VButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./VButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./VButtonGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports